export default "__VITE_ASSET__f3470ad3__"